import confetti from 'src/shared/assets/images/confetti.png';

import { ReactNode } from 'react';
import { classNames } from 'src/shared/lib/helpers/classNames';
import cls from './SuperBtn.module.scss';
import './SuperBtnColors.css';

interface ISuperBtn {
  text: string;
  color: string;
  size?: 's' | 'm' | 'l';
  onClick?: () => void;
  iconImg?: string
  withConfetti?: boolean
  className?: string
  after?: ReactNode
}

export const SuperBtn = ({
  text,
  color = '1',
  onClick,
  size = 'm',
  iconImg,
  withConfetti,
  className,
  after
}: ISuperBtn) => (
  <div className={
    classNames(
      cls.superBtn,
      {},
      [`superBtn_color${color}`, cls[size], className]
    )
  }
  >
    <button
      className={['superBtn__inner', cls.superBtn__inner].join(' ')}
      onClick={onClick}
      type='button'
    >
      {iconImg && (
        <img className={cls.superBtn__icon} src={iconImg} alt='diplom icon' />
      )}
      {text}
      {after}
    </button>

    {withConfetti && (
      <span className={cls.superBtn__confetti}>
        <img src={confetti} alt='confetti' />
      </span>
    )}

    <span className={cls.superBtn__stroke} />
  </div>
);
